import utils from 'utils'
import templateModal from './view/templateModal.html'

class templateSettingCtrl {
    constructor($scope, $uibModal, httpRequest, templateTreeService, $state, logger) {
        $scope.currentIndex = 0
        const reqObj = {}
        function initTree() {
            templateTreeService.getTemplateByOrg().then((res) => {
                if (res) {
                    $scope.cityName = res.cityName
                    $scope.modalObj = {
                        sjsfdqDm: res.obj.sjsfdqDm,
                        sfdqDm: res.obj.sfdqDm,
                    }
                    $scope.treeList = res.arr
                    reqObj.ruuid = $scope.treeList[0].children[0].ruuid
                    $scope.fatherIndex = $scope.treeList[0].nodeId
                    initTemp(reqObj)
                } else {
                    $scope.treeList = null
                    $scope.cityName = ''
                    $scope.declareData = null
                }
            })
        }
        initTree()
        $scope.treeNode = null
        $scope.addTemplate = function () {
            $uibModal.open({
                template: templateModal,
                controller: 'templateModalCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-template mod-modal mod-modal-hg',
                resolve: {
                    items1() {
                        return $scope.modalObj
                    },
                },
            }).result.then(() => {
                initTree()
            })
        }
        $scope.onSelectFather = function (item) {
            $scope.fatherIndex = item.nodeId
        }
        $scope.onSelectTreeNode = function onSelectTreeNode(node, index, item) {
            reqObj.ruuid = node.ruuid
            initTemp(reqObj)
            $scope.currentIndex = index
        }
        function initTemp(obj) {
            httpRequest.get_getOrgModelByRuuid(obj).then((res) => {
                $scope.declareData = res.data.value
            })
        }
        $scope.stateChange = function (val) {
            val === 1 ? logger.logSuccess('已启用') : logger.logSuccess('已禁用')
            const reqObj = {
                fbzluuid: this.$parent.item.fbzluuid,
                qyzt: val,
                ruuid: $scope.declareData.ruuid,
            }
            httpRequest.post_forbidFlzl(reqObj).then((res) => {

            })
        }
        $scope.openDetail = function openDetail(item) {
            console.log(item)
            const { path } = $scope.declareData
            const obj = utils.encode(JSON.stringify({
                path,
                item: item.xh - 1,
            }))
            const _url = $state.href(
                'system.settingcenter.templateSetting.detail',
                { obj }, { reload: true },
            )
            window.open(_url, '_blank')
        }
    }
}

templateSettingCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'templateTreeService', '$state', 'logger']
export default templateSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetting/templateSettingCtrl.js